import React, { useCallback, useEffect } from 'react'
import { Link } from 'react-router-dom'

import useDoHit from 'api/mutations/punch'
import withIdleTimer from 'lib/HOC/withIdleTimer'
import useStartQuickstart from 'lib/hooks/useStartQuickstart'
import { useWorkoutActions } from 'store/workout/selectors'
import Main from 'layout/main'
import Button from 'components/button'
import LoginBtn from 'components/login/login-btn'
import ConnectionIndicator from 'components/connection-indicator/connection-indicator'
import { APP_VERSION } from 'lib/app-version'
import AnnouncementButton from 'components/announcement-button/announcement-button'

const Home = () => {
  useStartQuickstart() // Quickstart workout starts when user punches the bag (or when developer clicks "HIT THE BAG" button on this page)
  const { resetWorkout } = useWorkoutActions()
  const doHit = useDoHit()

  useEffect(() => {
    resetWorkout()
  }, [resetWorkout])

  const fetchAppVersion = async () => {
    const response = await fetch('/index.html', { cache: 'no-store' });
    const html = await response.text();
    const match = html.match(/<meta name="app-version" content="(.+?)">/);
    return match ? match[1] : null;
  };

  const checkVersion = useCallback(async () => {
    const latestVersion = await fetchAppVersion();

    if (latestVersion && latestVersion !== APP_VERSION) {
      console.log('A new version is available!');
      window.location.reload();
    }
  }, []);

  // client wanted to refresh the page every 5 minutes to "refresh" the code
  // temporary taken out as we deploy a fix to the useAddHit hook
  useEffect(() => {
    checkVersion();

    const interval = setInterval(() => {
      checkVersion();
      window.location.reload();
    }, 5 * 60 * 1000) // 5 minutes

    return () => clearInterval(interval)
  }, [checkVersion])

  return (
    <Main className="nextround-home">
      <div className="home">
        <div className="home__header">
          <div className="home__header__logo" />
          <div className="home__header__btns">
            <AnnouncementButton />
            <ConnectionIndicator />
            <LoginBtn />
          </div>
        </div>
        <div>
          <div onClick={doHit} className="home__cta">
            <h1>HIT THE BAG</h1>
            <div className="home__cta__subTitle">To start Quickstart</div>
          </div>
        </div>
        <div className="home__button">
          <Link to="/workouts">
            <Button color="primary">
              <h3>Go to select workout</h3>
            </Button>
          </Link>
        </div>
        <div className="version-number">Version {APP_VERSION}</div>
      </div>
    </Main>
  )
}

export default withIdleTimer(Home)
